import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`In 2018, I joined my local chapter of `}<a parentName="p" {...{
          "href": "https://comingtothetable.org/"
        }}>{`Coming to the Table,`}</a>{` a unique anti-racist group that focuses on getting people of all races in the same room for regular, actual, in-person conversations.`}</p>
      <p>{`These are conversations I would never have had otherwise.`}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column colMd={6} colLg={6} mdxType="Column">
        <ArticleCard color="dark" title="Working together to create a just and truthful society that acknowledges and seeks to heal from the racial wounds of the past, from slavery and the many forms of racism it spawned." actionIcon="launch" href="https://comingtothetable.org" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.47222222222222%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVQoz5WS32/SUBTH+x/7YEJ48cFsw4claoIJmXES6oKTkaGLDKcdE9jAwdqttT/WXtrSlhbaMhgw6hz3tobqUDNnsu/TOTf53Ps933uwIJQfKrijsHmFfHRx6QVBYPSs9cq7MvfFC9v/XDqDr+BUtY1tcjeKx8gmk9x9c+/Fg0hqMVvNz33dCkuWEkkt3k8+XCXSmYOtVHFjOZeI4kuPsvG10qZggNt4bOiNCbocz798vPW8AWiCriznEis7a8/yyQJZTHzAFzJPt8kiQihM5a9osHQ5ly5tkjIjmfLKzqtsNf++8Wmfr58oXImtHQiNunTM6eK/bUOEIIIjbxwEfsvWI/jSV+1UMtVjhRMNuWlpkqnqjqU5Jq+D7sAV2+pwMp4NEvjYn5E45+5C5onummbPFnSZBGyVpz5S+29rhNRWqwJVF5nPzKHSMWa/g9AveIqgOzxbJV5H8VgsGxfa4NvV97PzgeM6SkevsA2uBYClHYp0t+92+k7T0nz/+uXJpSd3W6x2qto60+IL1J5qG+PJxWg06g36wFQpwO7RtcJRmdcACdgjwP6GbwoiNK9/7h8KT6YIQgR9fxb+D8RGTIeAgu/uAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Coming to the Table",
              "title": "Coming to the Table",
              "src": "/static/f026ab641c04e8438454cbfda2c94721/3cbba/cttt-logo.png",
              "srcSet": ["/static/f026ab641c04e8438454cbfda2c94721/7fc1e/cttt-logo.png 288w", "/static/f026ab641c04e8438454cbfda2c94721/a5df1/cttt-logo.png 576w", "/static/f026ab641c04e8438454cbfda2c94721/3cbba/cttt-logo.png 1152w", "/static/f026ab641c04e8438454cbfda2c94721/5dce9/cttt-logo.png 1500w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <p>{`CTTT gave me the chance to hear people old enough to remember desegregation talk
about their first days with their new white classmates who were afraid to touch
them… and a much younger man whose family moved to a nice Northern Virginia
neighborhood in the 80s and woke up in the night to the KKK shouting and filling
their lawn with garbage.`}</p>
    <p>{`When COVID hit, we had to move the meetings online. Our “email list” was
suddenly the lifeline for sending out the Zoom invites that would keep the group
alive… but it turned out to be a bunch of saved contacts in Gmail.`}</p>
    <p>{`In July 2020, I joined the Communications Committee and migrated these contacts
into a proper `}<a parentName="p" {...{
        "href": "https://mailchimp.com"
      }}>{`Mailchimp`}</a>{` list. Since then, I have taken
care of preparing and sending out the monthly newsletter. Although I have since
moved away from Virginia to Rochester, New York, the right tools make it easy
for me to keep taking care of this lovely group’s `}<a parentName="p" {...{
        "href": "https://mailchi.mp/2b7e5ffe098b/subscribe-to-cttt"
      }}>{`mailing
list`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      